<div class="cw-dialog">
    <h2>Auftrag prüfen</h2>
    <div class="cw-horizontalline"></div>

    <div class="cw-dialog-content">
        <p>
            Es {{ data.orders.length === 1 ? 'wurde' : 'wurden' }}
            <strong>{{ data.orders.length }}</strong>
            {{ data.orders.length === 1 ? 'Auftrag' : 'Aufträge' }}
            in den letzten 7 Werktagen gefunden:
        </p>

        <table class="duplicate-order-table">
            <thead>
                <tr>
                    <th>Datum</th>
                    <th>Summe</th>
                    <th>Mitarbeiter</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                @for (order of data.orders; track order.id) {
                    <tr>
                        <td>{{ formatDate(order.order_date) }}</td>
                        <td>{{ formatCurrency(order.order_total) }}</td>
                        <td>{{ getEmployeeName(order) }}</td>
                        <td>{{ getStatusLabel(order.order_status) }}</td>
                    </tr>
                }
            </tbody>
        </table>

        <p>Möchten Sie trotzdem einen neuen Auftrag anlegen?</p>
    </div>

    <div class="cw-button-wrapper">
        <button mat-raised-button color="accent" (click)="clickAndClose('yes')">Ja, anlegen</button>
        <button mat-raised-button color="primary" (click)="clickAndClose('no')">Nein</button>
    </div>
</div>
